import type { QueryKey } from '@tanstack/react-query'

export const sessionQueryKeys = {
  root: ['session'] as const,
  profile: (userId: string | null | undefined) => ['session', 'profile', userId ?? 'anonymous'] as const,
  preferences: (userId: string | null | undefined) => ['session', 'preferences', userId ?? 'anonymous'] as const,
  notificationsSummary: (userId: string | null | undefined) =>
    ['session', 'notifications-summary', userId ?? 'anonymous'] as const,
  notificationsList: (userId: string | null | undefined, pageSize: number) =>
    ['session', 'notifications-list', userId ?? 'anonymous', { pageSize }] as const,
  achievementsList: (
    userId: string | null | undefined,
    params: { category: string; unlocked: string; pageSize: number },
  ) => ['session', 'achievements-list', userId ?? 'anonymous', params] as const,
  inventorySummary: (userId: string | null | undefined) => ['session', 'inventory-summary', userId ?? 'anonymous'] as const,
} as const

export const domainQueryKeys = {
  dashboard: ['dashboard'] as const,
  manage: ['manage'] as const,
  emporium: ['emporium'] as const,
  arena: ['arena'] as const,
  social: ['social'] as const,
  notifications: ['session', 'notifications'] as const,
} as const

export function matchesQueryKeyPrefix(queryKey: QueryKey, prefix: readonly unknown[]): boolean {
  return prefix.every((segment, index) => queryKey[index] === segment)
}

export function isShellSessionQueryKey(queryKey: QueryKey, userId: string | null | undefined): boolean {
  const targetKeys = [
    sessionQueryKeys.profile(userId),
    sessionQueryKeys.preferences(userId),
    sessionQueryKeys.notificationsSummary(userId),
    sessionQueryKeys.inventorySummary(userId),
  ]

  return targetKeys.some((target) => JSON.stringify(queryKey) === JSON.stringify(target))
}
